import { ApolloCache } from '@apollo/client';

import { GetItemDataByIdQuery as IgetItemDataById } from '@notino/shared/definitions/types';

import getItemDataByIdQuery from '../ProductItem/queries/itemDataById.graphql';

export const updateWishlistedCache = ({
  cache,
  products,
}: {
  products: { productId: string; wishlisted: boolean }[];
  cache: ApolloCache<object>;
}) => {
  products.forEach((product) => {
    cache.updateQuery<IgetItemDataById>(
      {
        query: getItemDataByIdQuery,
        variables: { id: product.productId },
      },
      (prev) =>
        prev?.vpProductById
          ? {
              vpProductById: {
                ...prev.vpProductById,
                wishlisted: product.wishlisted,
              },
            }
          : prev
    );
  });
};
